import ENV from "config/Env";
import { typedQueryClient, usePermanentRealTimeUser, useTypedMutation } from "hooks";
import { DealerDocumentationsQueryKeys } from "modules/DealerDocumentations/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerDocumentation } from "models";

export const useCreateDocumentationMutation = () => {
  const { user } = usePermanentRealTimeUser();

  return useTypedMutation<DealerDocumentation, number>({
    mutationFn: async payload => (await ApiInstance.post("/documentations/create", payload, ENV.dealerBaseURL)).data.dealer_documentation_id,
    onSuccess: (payload, id) => {
      const dealerDocumentations = typedQueryClient.getQueryData(DealerDocumentationsQueryKeys.list);
      const newDealerDocumentation = { ...payload, id, created_by: user };

      if (!dealerDocumentations) {
        typedQueryClient.setQueryData(DealerDocumentationsQueryKeys.list, [newDealerDocumentation]);
        return;
      }

      const docIdx = dealerDocumentations.findIndex(doc => doc.id === id);

      typedQueryClient.setQueryData(
        DealerDocumentationsQueryKeys.list,
        docIdx === -1
          ? [...dealerDocumentations, newDealerDocumentation]
          : dealerDocumentations.with(docIdx, { ...dealerDocumentations[docIdx], ...newDealerDocumentation })
      );
    }
  });
};
